let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6wPv6")).then(() => parcelRequire('hEuLk'));